import { Injectable } from '@angular/core';
import { NotificationModel, NotificationService } from '@evorait/pace-core';

@Injectable({
    providedIn: 'root',
})
export class OverviewService {
    private currentNotificationIndex = -1;
    private notificationsList: NotificationModel[] = [];
    public constructor(private readonly notificationService: NotificationService) {}

    public getCurrentNotificationIndex(): number {
        return this.currentNotificationIndex;
    }

    public setCurrentNotificationIndex(notification: NotificationModel): void {
        this.currentNotificationIndex = this.notificationsList.findIndex((notificationModel) =>
            notificationModel.identifier.equalsTo(notification.identifier),
        );
    }

    public resetCurrentNotificationIndex(): void {
        this.currentNotificationIndex = -1;
    }

    public getNotificationList(): NotificationModel[] {
        return this.notificationsList;
    }

    public setNotificationList(): void {
        const notificationsList = this.notificationService
            .getTodaysNotifications()
            .concat(this.notificationService.getUpcomingNotifications())
            .concat(this.notificationService.getNewNotifications());
        // If a notification is cancelled, then its details screen should not be shown.
        this.notificationsList = notificationsList.filter((notification) => {
            const notificationStatus = this.notificationService.getStatus(notification);
            return !(
                notificationStatus.isCancelled() ||
                (this.notificationService.isNotificationCancelled(notification) &&
                    !this.notificationService.getCancellationConfirmationForInprogress(notification.identifier))
            );
        });
    }
}
